/**
 * Chats slice — the list of stored Deal-Analyst conversations for the project
 * (lightweight rows: chatId, title, preview, scenarios, timestamps) plus a
 * `pendingOpenId` used to signal the ChatPanel to load a chat chosen from the
 * history modal. Full message bodies live in the ChatPanel / the DB, not here.
 */
const initialState = {
  list: [],
  loaded: false,
  pendingOpenId: null, // set when a history row is clicked; ChatPanel consumes it
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CHATS":
      return { ...state, list: action.chats || [], loaded: true };

    case "UPSERT_CHAT": {
      const rest = state.list.filter((c) => c.chatId !== action.chat.chatId);
      // newest first
      return { ...state, list: [action.chat, ...rest].sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0)) };
    }

    case "REMOVE_CHAT":
      return { ...state, list: state.list.filter((c) => c.chatId !== action.chatId) };

    case "SET_PENDING_OPEN":
      return { ...state, pendingOpenId: action.chatId };

    case "CLEAR_PENDING_OPEN":
      return { ...state, pendingOpenId: null };

    case "CLEAR_PROJECT":
      return initialState;

    default:
      return state;
  }
};

export default reducer;
